import clsx from 'clsx';

import {Icon} from '../Icon/Icon';

import type {IconProp} from '@fortawesome/fontawesome-svg-core';

type Props = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  title: string;
  icon: IconProp;
};
export const ButtonGroupIconButton = ({
  ref,
  className,
  icon,
  ...props
}: Props & {
  ref?: React.RefObject<HTMLButtonElement>;
}) => {
  return (
    <button
      type="button"
      ref={ref}
      {...props}
      className={clsx(
        'relative inline-flex cursor-pointer items-center justify-center bg-slate1 px-2 py-2 text-sm font-semibold text-slate12 ring-1 ring-slate6 ring-inset hover:bg-slate3 focus-visible:z-10 focus-visible:bg-slate3 focus-visible:outline-hidden disabled:bg-slate2 disabled:text-slate11',
        className
      )}
    >
      <span className="sr-only">{props.title}</span>
      <Icon icon={icon} aria-hidden="true" />
    </button>
  );
};

ButtonGroupIconButton.displayName = 'ButtonGroupIconButton';
